<div class="flex flex-col gap-4">
  <p *ngIf="nzModalData?.productName" class="text-sm text-gray-600">
    How many tickets would you like to add for
    <span class="font-semibold text-gray-900">{{ nzModalData.productName }}</span>?
  </p>
  <p *ngIf="!nzModalData?.productName" class="text-sm text-gray-600">
    How many tickets would you like to add?
  </p>

  <div class="flex flex-col gap-1">
    <label for="quantity-selection" class="text-sm font-medium text-gray-700">
      Quantity
    </label>
    <nz-input-number
      id="quantity-selection"
      class="w-full"
      nzSize="large"
      [nzMin]="min"
      [nzMax]="max ?? undefined"
      [nzStep]="1"
      [(ngModel)]="quantity"
    ></nz-input-number>
  </div>

  <div
    *ngIf="(nzModalData?.unitPrice ?? 0) > 0"
    class="flex items-center justify-between rounded-md bg-gray-50 px-3 py-2 text-sm"
  >
    <span class="text-gray-600">Total</span>
    <span class="font-semibold text-gray-900">
      {{ total | currency: nzModalData?.currencyCode ?? 'USD' }}
    </span>
  </div>
</div>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="cancel()">Cancel</button>
  <button nz-button nzType="primary" (click)="confirm()">
    Add to cart
  </button>
</div>
